import React from 'react'

export default (
	<svg width='47' height='47' viewBox='0 0 42 42'>
		<defs>
			<linearGradient
				id='other-a'
				x1='0%'
				x2='95.861%'
				y1='50%'
				y2='50%'
			>
				<stop offset='0%' stopColor='#D44BD5' />
				<stop offset='100%' stopColor='#E94CBA' />
			</linearGradient>
			<path
				id='other-b'
				d='M23.1111111,21.3333333 C24.0888889,21.3333333 24.88,20.5333333 24.88,19.5555556 L24.8888889,10.6666667 C24.8888889,9.68888889 24.0888889,8.88888889 23.1111111,8.88888889 L8.88888889,8.88888889 C7.91111111,8.88888889 7.11111111,9.68888889 7.11111111,10.6666667 L7.11111111,19.5555556 C7.11111111,20.5333333 7.91111111,21.3333333 8.88888889,21.3333333 L5.33333333,21.3333333 L5.33333333,23.1111111 L26.6666667,23.1111111 L26.6666667,21.3333333 L23.1111111,21.3333333 Z M8.88888889,10.6666667 L23.1111111,10.6666667 L23.1111111,19.5555556 L8.88888889,19.5555556 L8.88888889,10.6666667 Z'
			/>
		</defs>
		<g fill='none' fillRule='evenodd'>
			{/* <circle
				cx='21'
				cy='21'
				r='21'
				fill='url(#other-a)'
				opacity='.35'
			/> */}
			<g transform='translate(5 5)'>
				<circle cx='16' cy='16' r='16' fill='url(#other-a)' />
				<use
					fill='#FFF'
					fillRule='nonzero'
					href='#other-b'
				/>
			</g>
		</g>
	</svg>
)
